import PropertyLister from '../controller'
import View from './view'

export default class PropertyMap extends PropertyLister {

    constructor(finder) {
        super(finder)
        this.view = new View(this)
        this.title = 'Karta för: '

        this.mapRoot = ''
    }

    fillMap() {
        this.mapRoot = this.view.multiMarkerMap()
        return this
    }

    manage(data) {
        this.props.projekts = data.projekts
        return this
    }

    render() {
        this
            .fillTitle()
            .fillMap()

        return [this.titleRoot, this.mapRoot]
    }

}
